// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VVO7Q","tabsBox":"styles_tabsBox__2T49I","createButton":"styles_createButton__20hWK"};